export default __webpack_public_path__ + "static/ISO27001-d3552aa26a9e5a0e3520e2c9d0399050.png";